// src/components/guards/GuardsFilters.jsx
import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const GuardsFilters = ({
  statusFilter,
  onStatusFilterChange,
  visibleCount,
  totalGuards,
}) => {
  const { theme } = useTheme();

  return (
    <div className="mb-4 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
      <div className="flex flex-wrap items-center gap-2">
        <button
          onClick={() => onStatusFilterChange('all')}
          className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-all ${
            statusFilter === 'all'
              ? 'border-transparent text-white shadow-sm'
              : 'border-slate-200 bg-white text-slate-600'
          }`}
          style={
            statusFilter === 'all'
              ? {
                  background: `linear-gradient(135deg, ${theme.primary[500]} 0%, ${theme.secondary[600]} 100%)`,
                }
              : {}
          }
        >
          All
        </button>
        <button
          onClick={() => onStatusFilterChange('active')}
          className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-all ${
            statusFilter === 'active'
              ? 'border-transparent text-white shadow-sm'
              : 'border-emerald-200 bg-emerald-50 text-emerald-700'
          }`}
          style={
            statusFilter === 'active'
              ? {
                  background: `linear-gradient(135deg, ${theme.primary[500]} 0%, ${theme.secondary[500]} 100%)`,
                }
              : {}
          }
        >
          Active
        </button>
        <button
          onClick={() => onStatusFilterChange('inactive')}
          className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-all ${
            statusFilter === 'inactive'
              ? 'border-transparent text-white shadow-sm'
              : 'border-slate-200 bg-slate-50 text-slate-600'
          }`}
          style={
            statusFilter === 'inactive'
              ? {
                  background: `linear-gradient(135deg, ${theme.primary[500]} 0%, ${theme.secondary[500]} 100%)`,
                }
              : {}
          }
        >
          Inactive
        </button>
      </div>
      <p className="text-xs text-slate-500">
        Showing {visibleCount} of {totalGuards} guards
      </p>
    </div>
  );
};

export default GuardsFilters;
